import z from "zod";

import { EventStatsSchema } from "../../../models";

export const Select = {
  minTicketPrice: true,
  nextSessionAt: true,
  ticketsAvailable: true
} as const;

export const Schema = EventStatsSchema.pick(Select);

export type Type = z.infer<typeof Schema>;
